import React from 'react'

const RPCard = ({child}) => {
  return (
    <div className="p-4 bg-white rounded shadow-md flex flex-col items-center">
        {child}
    </div>
  )
}

export default RPCard